import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import "../styles/SidebarMenu.css";
import apiUrl from "../../config";

const SidebarMenu = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const stored = localStorage.getItem("sidebarCollapsed");
        setCollapsed(stored === "true");
    }, []);

    useEffect(() => {
        localStorage.setItem("sidebarCollapsed", collapsed);
    }, [collapsed]);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await axios.get(`${apiUrl}/api/auth/check-session`, {
                    withCredentials: true,
                });
                setIsLoggedIn(res.data.authenticated);
            } catch {
                setIsLoggedIn(false);
            }
        };
        checkAuth();
    }, []);

    const handleToggleCollapse = () => {
        // Only allow toggle on screens wider than 768px
        if (window.innerWidth > 768) {
            setCollapsed((prev) => !prev);
        }
    };

    const handleLogout = async () => {
        try {
            await axios.post(`${apiUrl}/api/auth/logout`, {}, { withCredentials: true });
            navigate("/manager/signin");
            setIsLoggedIn(false);
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    return (
        <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
            <div className="sidebar-header">
                {!collapsed && <h2>My Admin</h2>}
                <button
                    className="collapse-btn"
                    onClick={handleToggleCollapse}
                    aria-label="Toggle Sidebar"
                >
                    <FontAwesomeIcon icon="bars" />
                </button>
            </div>

            <nav className="sidebar-nav">
                <ul>
                    <li>
                        <NavLink to="/manager/dashboard" className={({ isActive }) => isActive ? "active" : ""}>
                            <span className="sidebar-link-content">
                                <FontAwesomeIcon icon="house" className="sidebar-icon" />
                                {!collapsed && "Dashboard"}
                            </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/manager/event" className={({ isActive }) => isActive ? "active" : ""}>
                            <span className="sidebar-link-content">
                                <FontAwesomeIcon icon="calendar" className="sidebar-icon" />
                                {!collapsed && "Events"}
                            </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/manager/menu" className={({ isActive }) => isActive ? "active" : ""}>
                            <span className="sidebar-link-content">
                                <FontAwesomeIcon icon="utensils" className="sidebar-icon" />
                                {!collapsed && "Menu"}
                            </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/manager/reservations" className={({ isActive }) => isActive ? "active" : ""}>
                            <span className="sidebar-link-content">
                                <FontAwesomeIcon icon="address-book" className="sidebar-icon" />
                                {!collapsed && "Reservations"}
                            </span>
                        </NavLink>
                    </li>
                    <li>
                        <button
                            onClick={isLoggedIn ? handleLogout : () => navigate("/manager/signin")}
                            className="sidebar-action-btn"
                        >
                            <span className="sidebar-link-content">
                                <FontAwesomeIcon
                                    icon={isLoggedIn ? "right-from-bracket" : "right-to-bracket"}
                                    className="sidebar-icon"
                                />
                                {!collapsed && (isLoggedIn ? "Logout" : "Sign In")}
                            </span>
                        </button>
                    </li>
                </ul>
            </nav>
        </aside>
    );
};

export default SidebarMenu;
